import { render, staticRenderFns } from "./ChallengeForum.vue?vue&type=template&id=a0b25512&scoped=true"
import script from "./ChallengeForum.vue?vue&type=script&lang=ts"
export * from "./ChallengeForum.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeForum.vue?vue&type=style&index=0&id=a0b25512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b25512",
  null
  
)

export default component.exports